import React from 'react'
import { Outlet } from "react-router-dom";

//Laanding
import FooterLanding from './components/FooterLanding';
import NavbarLanding from './components/NavbarLanding';

 
function LandingLayout() {
  return (
    <>
      <NavbarLanding />
      <main>
        <Outlet />
      </main>
      <FooterLanding />
    </>
  )
}

export default LandingLayout